import { CreateAccountForm } from "../../components";

export default function CreateAccountPage() {
    return(<div>
        <CreateAccountForm />
        
    </div>)
}